// extracted by mini-css-extract-plugin
module.exports = {"root":"DownloadPoster_root__T3LFT","posterImage":"DownloadPoster_posterImage__DNyMZ","downloadButton":"DownloadPoster_downloadButton__zrtyq"};